import React, { useState } from 'react';
import { DataGridTypes } from 'devextreme-react/data-grid';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { parameterService } from '@/projects/platform/services/parameter-service';
import { parameterService as adminParameterService } from '@/projects/admin/services/parameter-service';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const ParameterDetails = (props: DataGridTypes.MasterDetailTemplateData) => {
  const { code } = props.data.data;

  const [parameterDetails] = useState(() => createCustomStore({
    key: ['id'],
    load:parameterService.getParameters,
    byKey: (key, loadOptions) => {
        if (key) {
            loadOptions.filter = ["id", "=", key];
        }
    },
    onLoading(loadOptions) {
      loadOptions.filter = [["ParentId", "<>", null], "and", ["ParentCode", "=", code]]
    },
    insert:adminParameterService.createParameter,
    update:adminParameterService.updateParameter,
    remove:adminParameterService.deleteParameter,
    useDefaultSearch: true
  }));

  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };
  const navigate = useNavigate();

  const goToEdit = (id: string) => {
    navigate(`/admin/parameter-definition/${id}`, { state: { id: id } })
  }
  return (
    <React.Fragment>
      <DataGridWrapper
        props={{ id: 'detailGrid' }}
        datasource={parameterDetails}
        onRowUpdating={handleRowUpdating}
        filterVisible={true}
        headerFilterVisible={true}
        remoteOperations={false}
        enableCustomToolbarContent={true}
        editingConfig={{ refreshMode: 'reshape', mode: 'row', allowDeleting: true, allowUpdating: true, confirmDelete: true, deleteMessageText: RemoveMessage('Parameter') }}
        columns={[
          { dataField: 'applicationName', caption: t('application') },
          { dataField: 'code', caption: t('name') },
          { dataField: 'description', caption: t('description') },
          { dataField: 'longDescription', caption: t('summary') },
          { dataField: 'order', caption: t('parameter_order') }
        ]}
        buttonConfig={[
          {
            name: 'edit',
            icon: 'edit',
            onClick: function (e: any) {
              goToEdit(e.row?.data.id);
            },
          },
          {
            name: 'delete',
            icon: 'trash',
          },
        ]}
      />
    </React.Fragment>

  );
};

export default ParameterDetails;
